export default __webpack_public_path__ + "static/media/Flag_of_Switzerland.6f88028e.svg";